// extracted by mini-css-extract-plugin
export default {"errorWrap":"InputError_errorWrap__p5HF-","errorTip":"InputError_errorTip__agciP","isError":"InputError_isError__yxfb2"};